export enum EColors {
  LushBlue = '#001D3A',
  RaspberryRed = '#E30B40',
  LightBlue = '#2969a8',
  PaleRed = '#fce7ec',
  LushRed = '#D11A2A',
  Green = '#4BB543',
  Grey = '#d1d1d1',
  PaleGrey = '#f5fdf5',
  LightGrey = '#FAFAFA',
  BluishGrey = '#e1e1e8',
  YetAnotherGrey = '#c8c8c8',
  Silver = '#BCBCCA',
  YellowOrange = '#ff9933',
  Black = '#000000',
  White = '#ffffff',
  Yellowish = '#fffce4',
  BorderColor = '#F0F0F0',
}
